export const ExamActionTypes = {
  SET_QUESTION_LIST: "SET_QUESTION_LIST",
  ADD_QUESTION: "ADD_QUESTION",
  EDIT_QUESTION: "EDIT_QUESTION",
  DELETE_QUESTION: "DELETE_QUESTION",

  SET_QUESTION_BANK_LIST: "SET_QUESTION_BANK_LIST",
  ADD_QUESTION_BANK: "ADD_QUESTION_BANK",
  EDIT_QUESTION_BANK: "EDIT_QUESTION_BANK",
  DELETE_QUESTION_BANK: "DELETE_QUESTION_BANK",
};
